import { useState, useEffect } from 'react';

const useFixedElement = (threshold) => {
	const [isFixed, setIsFixed] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			const scrollPosition = window.scrollY;
			setIsFixed(scrollPosition > threshold);
		};

		window.addEventListener('scroll', handleScroll);
		handleScroll();

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, [threshold]);

	return isFixed;
};

export default useFixedElement;
